import { Component, OnInit, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl } from '@angular/forms';
import { AbstractCustomControlComponent } from '../abstract-custom-control/abstract-custom-control.component';
import { Observable, of } from 'rxjs';
import { User } from '../../../models/user.model';
import { UserService } from '../../../services/user.service';
import { HttpParams, HttpClient } from '@angular/common/http';
import { startWith, tap, switchMap, map } from 'rxjs/operators';
import { UserMDRef } from '../../../models/medical-center.model';
import { Page } from '../../../models/page.model';
import { MedicalCenterService } from '../../../services/medical-center.service';


@Component({
  selector: 'app-medical-user-autocomplete',
  templateUrl: './medical-user-autocomplete.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MedicalUserAutocompleteComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MedicalUserAutocompleteComponent),
      multi: true
    }
  ]
})
export class MedicalUserAutocompleteComponent extends AbstractCustomControlComponent implements OnInit {


  @Input() value: any;
  @Input() searchFn: (params) => Observable<Page<User>>;
  private _users: UserMDRef[];

  medicalUsers: Observable<UserMDRef[]>;
  selectedUser = new FormControl();

  @Input() set users(value: UserMDRef[]) {
    this._users = value;
    this.selectedUser.patchValue(null);
  }

  get users(): UserMDRef[] {
      return this._users;
  }

  constructor(
    private userService: UserService,
  ) {
    super();
  }

  get isDisabled() {
    return this.users && this.users.length === 0;
  }

  ngOnInit() {
      if (!this.searchFn) {
        this.searchFn = this.userService.getUserList.bind(this.userService);
      }
      this.medicalUsers = this.selectedUser.valueChanges
        .pipe(
          startWith(''),
          tap(value => {
            if (this.selectedUser.dirty && !value.id) {
              this.writeValue(null);
            }
          }),
          switchMap(value => this.filterValues(value))
        );

      if (this.value) {
        this.userService.getUserByUsername(this.value)
          .pipe(map(user => this.mapUserMDRef(user)))
            .subscribe(res => {
              this.selectedUser.setValue(res);
              this.writeValue(res.username);
            });
      }
  }

  onSelectUser(selected) {
    const medicalUser = selected.option.value;
    this.value = medicalUser.username;
    this.onChange(this.value);
  }

  userDisplayFn(medicalUser: UserMDRef): string {
    if (medicalUser && medicalUser.firstName) {
      return `${medicalUser.firstName} ${medicalUser.lastName}`;
    }
    if (medicalUser && medicalUser.username) {
      return medicalUser.username;
    }
    return '';
  }

  filterValues(value): Observable<UserMDRef[]> {
    if (this.users !== undefined) {
      return of(this.users);
    }
    return this.searchFn(
      new HttpParams().set('page', '0').set('username', value)).pipe(
        map(res => res.content.map(user => this.mapUserMDRef(user))));
  }

  private mapUserMDRef(user: User): UserMDRef {
      return Object.assign(new UserMDRef(), user, {
        id: user.id,
        username: user.username,
        firstName: user.userInfo.firstName,
        lastName: user.userInfo.lastName
      });
  }
}
